import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import { Data } from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject } from 'rxjs';
import { CASH_REGISTERS } from '../../../../data/cash-registers';
import { ICashRegister as ICashRegisterOld } from '../../../../model/cash-register-old';
import { CashRegisterSession } from "../../../../model/cash-register-session";
import { ICashRegisterSessionsApiService } from './cash-register-sessions-api.interface';
import { Paginated } from '@orderna/admin-panel/src/types/pagination';
import { FindRegisterSessionsQueryDto } from './dtos/find-register-sessions.query.dto';
import { FindRegisterSessionsResponseDto } from './dtos/find-register-sessions.response.dto';

interface ICashRegister extends ICashRegisterOld {
  createdAt: Date;
}

@Injectable({
  providedIn: 'root',
})
export class CashRegisterSesssionsMockApiService
  implements ICashRegisterSessionsApiService
{
  private cashRegisters: ICashRegister[] = [...CASH_REGISTERS]?.map(
    (register: ICashRegisterOld) => {
      const newRegister: ICashRegister = { ...register, createdAt: new Date() };
      return newRegister;
    }
  );

  data = {
    register_summaries: {
      items: [] as CashRegisterSession[],
      queryOptions: { page: 1, size: 10 } as QueryOptions<CashRegisterSession>,
      subject: new BehaviorSubject<Maybe<Paginated<CashRegisterSession>>>(
        null
      ),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };
  get registerSummariesData() {
    return this.data['register_summaries'] as Data<
      CashRegisterSession,
      CashRegisterSession
    >;
  }

  findRegisterSessions(query: FindRegisterSessionsQueryDto): Promise<FindRegisterSessionsResponseDto> {
    throw new Error('Method not implemented.');
  }
}
